import React from 'react'
import { Draggable as DraggableDnD } from 'react-beautiful-dnd'
import Card from './card'
import { WrapperRow } from './styles'

// import { Container } from './styles'

type IProps = {
  item: any;
  data: any;
  index: number;
  actionItem: any;
}

const Draggable = ({
  item,
  data,
  actionItem,
  index,
}: IProps) => (
  <DraggableDnD
    draggableId={String(item.item.id)}
    index={index}
  >
    {
      (providedDrag) => (
        <WrapperRow
          {...providedDrag.draggableProps}
          {...providedDrag.dragHandleProps}
          ref={providedDrag.innerRef}
        >
          <Card
            isDraggable
            data={data}
            group={item}
            actionItem={actionItem}
          />
        </WrapperRow>
      )
    }
  </DraggableDnD>
)

export default Draggable
